import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CalendarDaysIcon, CheckIcon, Clock3Icon, CookingPotIcon, DownloadIcon, LeafIcon, LockKeyholeIcon, MonitorSmartphoneIcon, NotebookPenIcon, SaladIcon, SparklesIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, handleCheckoutClick } from '../utils/checkout';
const products = [{
  label: 'PRODUCTO PRINCIPAL',
  title: 'Hábitos para una Vida Saludable',
  icon: BookOpenIcon,
  description: 'La guía principal para dejar de improvisar y aprender a comer mejor con una estrategia que se adapta a tu vida.',
  image: 'https://cdn.magicpatterns.com/uploads/8qqeT9itbTEfWdJ6h8w9LR/ChatGPT_Image_17_jul_2026,_09_37_05.png',
  benefits: ['Qué elegir para sentirte bien', 'Hábitos saludables y realistas', 'Cómo organizar tus comidas', 'Calendario de alimentación de 30 días', 'Ideas para cada momento del día', 'Menús para orientarte', 'Meal Prep sin complicaciones', 'Explicaciones claras para empezar'],
  featured: true
}, {
  label: 'BONO PREMIUM #1',
  title: 'Cocina Antiinflamatoria',
  icon: SaladIcon,
  description: 'Un recetario complementario con opciones, jugos verdes y smoothies para sumar variedad a tus comidas cotidianas.',
  image: 'https://cdn.magicpatterns.com/uploads/ew4zYGVwXbmFnKLfyms136/bono_3_CF.png',
  benefits: ['Desayunos', 'Almuerzos', 'Cenas', 'Snacks', 'Jugos verdes', 'Smoothies', 'Sopas', 'Postres saludables', 'Ingredientes fáciles de conseguir', 'Preparación paso a paso'],
  featured: false
}, {
  label: 'BONO PREMIUM #2',
  title: 'Recetario Déficit Calórico',
  icon: CookingPotIcon,
  description: 'Un complemento pensado para quienes buscan opciones saciantes y prácticas dentro de una alimentación equilibrada.',
  image: 'https://cdn.magicpatterns.com/uploads/wzKGsUFS67E9tmbeSAkRpg/bono_2_CF.png',
  benefits: ['Más de 120 recetas', 'Altas en proteína', 'Bajas en calorías', 'Desayunos', 'Almuerzos', 'Cenas', 'Meriendas', 'Postres Fitness', 'Información nutricional', 'Meal Prep', 'Recetas listas en menos de 30 minutos'],
  featured: false
}, {
  label: 'BONO PREMIUM #3',
  title: 'Planificador Nutricional',
  icon: CalendarDaysIcon,
  description: 'La herramienta complementaria para ordenar tu semana y convertir las buenas intenciones en acciones concretas.',
  image: 'https://cdn.magicpatterns.com/uploads/qa3vi2EPaBMrMf36ySks4p/bono_1_CF.png',
  benefits: ['Planificador semanal', 'Organización diaria', 'Seguimiento de agua', 'Seguimiento de ejercicio', 'Registro de hábitos', 'Lista inteligente de compras', 'Control de progreso', 'Espacio para notas', 'Objetivos semanales'],
  featured: false
}];
const learning = [['Comer mejor sin extremos', LeafIcon], ['Organizar tus comidas', NotebookPenIcon], ['Crear hábitos sostenibles', SparklesIcon], ['Resolver desayunos', CookingPotIcon], ['Resolver almuerzos', SaladIcon], ['Resolver cenas', CookingPotIcon], ['Tener meriendas a mano', SaladIcon], ['Meal Prep práctico', Clock3Icon], ['Entender el déficit calórico', LeafIcon], ['Explorar cocina antiinflamatoria', SparklesIcon], ['Preparar jugos verdes', SaladIcon], ['Sumar smoothies saludables', LeafIcon]];
export function OfferLearning() {
  return <>
      <section id="incluye" className="relative overflow-hidden bg-[#fffefa] py-24 sm:py-32" data-id="element-179" data-mp="2v872ywogv3js">
        <LeafIcon aria-hidden="true" className="absolute -right-10 top-40 h-36 w-36 rotate-[24deg] text-[#e2eadc]" strokeWidth={0.9} data-id="element-180" data-mp="301jeq681rfv4" />
        <div className="relative mx-auto max-w-7xl px-5 sm:px-8" data-id="element-181" data-mp="27iw3rjmrlh7r">
          <header className="mx-auto max-w-4xl text-center" data-id="element-182" data-mp="d3fh1jbgy7oy">
            <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-183" data-mp="d3p6n5slqcu4">
              ACCESO DIGITAL INMEDIATO
            </p>
            <h2 className="font-display mt-5 text-4xl leading-tight text-[#2d3b2c] sm:text-5xl" data-id="element-184" data-mp="mt8rui3seis5">
              Una forma más simple de cambiar cómo comes y cómo te sientes.
            </h2>
            <div className="mx-auto mt-7 max-w-3xl space-y-5 text-lg leading-8 text-[#63705f]" data-id="element-185" data-mp="i0pb5c9sz7j4">
              <p data-id="element-186" data-mp="wt9d49l7v8yz">Esto no es otro libro digital que terminará olvidado.</p>
              <p data-id="element-187" data-mp="rrtuspafbgka">
                Es un sistema completo para cuando ya te cansaste de intentar
                dietas, abandonar a mitad de camino y volver a preguntarte qué
                cocinar cada día.
              </p>
              <p data-id="element-188" data-mp="10r75flaaab6l">
                Cada guía, receta y herramienta tiene un propósito: ayudarte a
                organizarte, disfrutar tu comida y construir hábitos que puedas
                sostener incluso en las semanas más ocupadas.
              </p>
            </div>
          </header>

          <motion.article initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.1
        }} transition={{
          duration: 0.55
        }} className="mt-16 overflow-hidden border border-[#e0e4da] bg-[#fcfbf7] shadow-[0_12px_34px_rgba(53,70,49,0.07)] lg:grid lg:grid-cols-[.76fr_1.24fr] lg:items-stretch" data-id="element-189" data-mp="1i4oqyrnijq7n">
            <div className="relative flex min-h-[420px] items-center justify-center bg-[#eef1e7] p-8 sm:p-12 lg:min-h-[640px]" data-id="element-190" data-mp="qc7wf208lx3x">
              <span className="absolute left-6 top-6 bg-[#fffefa] px-3 py-2 text-[10px] font-bold tracking-[0.16em] text-[#52664c] shadow-sm" data-id="element-191" data-mp="ud1kbvdojbwt">
                PRODUCTO PRINCIPAL
              </span>
              <img src={products[0].image} alt="Portada de la guía Hábitos para una Vida Saludable" className="relative h-auto max-h-[530px] w-auto max-w-[330px] object-contain shadow-[14px_20px_32px_rgba(38,48,35,0.22)] sm:max-w-[400px]" data-id="element-192" data-mp="2opzqq3w9doev" />
            </div>

            <div className="p-8 sm:p-12 lg:p-14" data-id="element-193" data-mp="3oovzojysst6p">
              <div className="flex items-center gap-3 text-[#66805c]" data-id="element-194" data-mp="3jozvokq3p1r5">
                <LeafIcon size={21} strokeWidth={1.5} aria-hidden="true" data-id="element-195" data-mp="k9corgock63z" />
                <p className="text-[11px] font-bold tracking-[0.16em]" data-id="element-196" data-mp="kanrdd6237ti">
                  🌿 TU GUÍA PRINCIPAL
                </p>
              </div>
              <h3 className="font-display mt-5 text-3xl text-[#30452e] sm:text-4xl" data-id="element-197" data-mp="bfhkeav1ujpe">
                Hábitos para una Vida Saludable
              </h3>
              <p className="mt-4 max-w-xl text-lg leading-8 text-[#42573f]" data-id="element-198" data-mp="13wtvh8q0buqx">
                Un método paso a paso para comer mejor sin convertir tu vida en
                una dieta eterna.
              </p>

              <div className="mt-7 max-w-2xl space-y-4 leading-7 text-[#62705f]" data-id="element-199" data-mp="16hi3gz7iz3py">
                <p data-id="element-200" data-mp="16jl56gi1ilai">
                  Esta es la guía central para volver a sentir claridad frente a
                  tu alimentación.
                </p>
                <p data-id="element-201" data-mp="1gemtja4hrjc1">
                  Te ayuda a organizar tus comidas, resolver el “¿qué cocino
                  hoy?” y crear una rutina que no dependa de motivación perfecta.
                </p>
                <p data-id="element-202" data-mp="1pfb6s2m29fnv">
                  Si has probado de todo y nada se ha sostenido, aquí encontrarás
                  un punto de partida simple y aplicable.
                </p>
                <p data-id="element-203" data-mp="1z5no7lykwsps">
                  Todo está explicado con ejemplos claros y herramientas listas
                  para usar desde el primer día.
                </p>
              </div>

              <h4 className="mt-9 text-[11px] font-bold uppercase tracking-[0.16em] text-[#52664c]" data-id="element-204" data-mp="28740jz8yf4wn">
                Con esta guía aprenderás a:
              </h4>
              <ul className="mt-5 grid gap-x-7 gap-y-3 sm:grid-cols-2" data-id="element-205" data-mp="2d3lz2hdoy70j">
                {['Comer mejor sin sentir que vives a dieta.', 'Organizar tus comidas con menos esfuerzo.', 'Crear hábitos realistas para tu rutina.', 'Tener ideas claras para cada momento del día.', 'Usar un calendario de alimentación de 30 días como guía.', 'Ahorrar tiempo con Meal Prep práctico.', 'Dejar de improvisar desayunos, almuerzos, cenas y meriendas.', 'Disfrutar la comida mientras cuidas de ti.'].map(benefit => <li key={benefit} className="flex items-start gap-2.5 text-sm leading-6 text-[#586655]" data-id="element-206" data-mp="2pgqobadw2hws">
                    <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={15} strokeWidth={2} data-id="element-207" data-mp="1wz4kih6i4llv" />
                    <span data-id="element-208" data-mp="7ismkfum5iei">{benefit}</span>
                  </li>)}
              </ul>

              <aside className="mt-9 rounded-2xl border border-[#d8e5d0] bg-[#eff5ea] p-6 sm:p-7" data-id="element-209" data-mp="c8z9mb9h8uun">
                <h4 className="font-display text-2xl text-[#354a33]" data-id="element-210" data-mp="3tq0n94ul9147">
                  Lo mejor de Hábitos para una Vida Saludable
                </h4>
                <div className="mt-4 space-y-2.5 text-sm leading-6 text-[#53634e]" data-id="element-211" data-mp="2jpfkpv2p23w">
                  <p data-id="element-212" data-mp="qabn8g160kdd">No tienes que vigilar cada bocado.</p>
                  <p data-id="element-213" data-mp="v7v0bcm4mr3q">
                    No tienes que eliminar de golpe todo lo que disfrutas.
                  </p>
                  <p data-id="element-214" data-mp="h93pbz2k9ljt">No tienes que seguir reglas imposibles de mantener.</p>
                  <p className="font-semibold text-[#405a3b]" data-id="element-215" data-mp="l9nm31j82n5f">
                    Solo necesitas una guía clara para avanzar paso a paso.
                  </p>
                </div>
              </aside>

              <div className="mt-7" data-id="element-216" data-mp="35zwg4ni6yj8g">
                <a href={checkoutUrl} onClick={handleCheckoutClick} className="inline-flex min-h-14 w-full items-center justify-center rounded-full bg-[#405a3b] px-7 text-center text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.14)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304a2d] hover:shadow-[0_14px_25px_rgba(48,69,46,0.2)] sm:w-auto" data-id="element-217" data-mp="360xup1yf1nux">
                  🍃 QUIERO COMENZAR HOY
                </a>
                <div className="mt-4 flex flex-wrap gap-x-3 gap-y-2 text-xs font-medium text-[#64745f]" data-id="element-218" data-mp="3jdh3euoqlita">
                  <span data-id="element-219" data-mp="3o8ea3uyjng30">🔒 Pago 100% seguro</span>
                  <span className="text-[#9aa893]" data-id="element-220" data-mp="3abhi3q6ovskj">•</span>
                  <span data-id="element-221" data-mp="3ad2d1gwx1dix">⚡ Acceso inmediato</span>
                  <span className="text-[#9aa893]" data-id="element-222" data-mp="3edco37zkeu4n">•</span>
                  <span data-id="element-223" data-mp="18jcugqw83hfm">📥 Descarga digital</span>
                  <span className="text-[#9aa893]" data-id="element-224" data-mp="18knxgohugl5o">•</span>
                  <span data-id="element-225" data-mp="1ckohqprmjqkn">📱 Compatible con celular, tablet y computadora</span>
                  <span className="text-[#9aa893]" data-id="element-226" data-mp="1cilnftjfvba4">•</span>
                  <span data-id="element-227" data-mp="2x3s459cvdnzq">💚 Pago único</span>
                </div>
                <p className="font-display mt-7 max-w-2xl text-xl leading-8 text-[#3e573a] sm:text-2xl" data-id="element-228" data-mp="2t1x5ydq8jqq6">
                  No necesitas cambiar tu vida en un día. Necesitas un sistema
                  que te ayude a sostener pequeñas decisiones hasta que comer
                  mejor se sienta natural. Para eso existe Hábitos para una Vida
                  Saludable.
                </p>
              </div>
            </div>
          </motion.article>

          <aside className="relative mx-auto mt-14 max-w-5xl overflow-hidden rounded-[28px] border border-[#d8e2d2] bg-[#f2f5ec] px-6 py-12 text-center shadow-[0_14px_32px_rgba(55,75,49,0.08)] sm:px-12 sm:py-16" aria-labelledby="bonuses-introduction-title" data-id="element-229" data-mp="3btzfz68dg8rg">
            <LeafIcon aria-hidden="true" className="absolute -left-5 top-7 h-24 w-24 -rotate-[28deg] text-[#b7caaa]/45" strokeWidth={1} data-id="element-230" data-mp="1vdvg1oer0497" />
            <LeafIcon aria-hidden="true" className="absolute -right-5 bottom-7 h-28 w-28 rotate-[32deg] text-[#c9d8bb]/55" strokeWidth={1} data-id="element-231" data-mp="3qicrw0ag3ofi" />
            <div className="relative mx-auto max-w-3xl" data-id="element-232" data-mp="480e1of11zn0">
              <div className="flex items-center justify-center gap-3 text-[#657d5c]" data-id="element-233" data-mp="8bol85zqyt7q">
                <span aria-hidden="true" className="h-px w-10 bg-[#9db093]" data-id="element-234" data-mp="dajddyjltu4i" />
                <p className="text-[11px] font-bold tracking-[0.18em]" data-id="element-235" data-mp="d8fc7od3b97x">
                  Y esto es solo el comienzo…
                </p>
                <span aria-hidden="true" className="h-px w-10 bg-[#9db093]" data-id="element-236" data-mp="mzjhtxgvlhq3" />
              </div>
              <h3 id="bonuses-introduction-title" className="font-display mt-5 text-3xl leading-tight text-[#30452e] sm:text-4xl" data-id="element-237" data-mp="rznvlfqefycm">
                Tu cambio también merece herramientas que te acompañen
              </h3>
              <p className="mx-auto mt-6 max-w-3xl leading-7 text-[#5e6d58] sm:text-lg sm:leading-8" data-id="element-238" data-mp="10xhoshsvabvk">
                Al adquirir Hábitos para una Vida Saludable, también recibirás{' '}
                <span className="font-bold text-[#3f683d]" data-id="element-239" data-mp="2gkwini0ifsnu">
                  tres bonos premium incluidos sin costo adicional
                </span>
                , creados para ayudarte a organizarte mejor, disfrutar comidas
                deliciosas y convertir tus nuevos hábitos en una forma de vida más
                sencilla y sostenible.
              </p>
              <p className="font-display mt-7 text-xl text-[#405e3e] sm:text-2xl" data-id="element-240" data-mp="3082irgszvq5u">
                Más apoyo. Más claridad. Más razones para comenzar hoy.
              </p>
              <div className="mx-auto mt-8 h-px w-20 bg-[#b6c9aa]" data-id="element-241" data-mp="2qhho24gfz5s7" />
              <p className="mt-6 text-sm font-semibold text-[#52684e] sm:text-base" data-id="element-242" data-mp="2qf54xnyy6pdk">
                Descubre todo lo que recibirás junto con tu producto principal:
              </p>
              <span aria-hidden="true" className="mx-auto mt-7 flex h-10 w-10 items-center justify-center rounded-full border border-[#aabda0] bg-[#fffefa] text-xl leading-none text-[#557250] shadow-sm" data-id="element-243" data-mp="3j3k8necmpl9l">
                ↓
              </span>
            </div>
          </aside>

          <div className="mt-10 grid gap-8 lg:grid-cols-2" data-id="element-244" data-mp="2yoj427qwid2y">
            {products.slice(1).map((product, index) => {
            const ProductIcon = product.icon;
            return <motion.article key={product.title} initial={{
              opacity: 0,
              y: 18
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.1
            }} transition={{
              duration: 0.5,
              delay: index * 0.05
            }} className="overflow-hidden border border-[#e0e4da] bg-[#fcfbf7] shadow-[0_12px_34px_rgba(53,70,49,0.07)]" data-id="element-245" data-mp="3qfp6wvy0aovx" data-mpi={index}>
                  <div className="relative flex min-h-[350px] items-center justify-center bg-[#eef1e7] p-8 sm:min-h-[410px]" data-id="element-246" data-mp="j9fmjnzt5zgk">
                    <span className="absolute left-6 top-6 bg-[#fffefa] px-3 py-2 text-[10px] font-bold tracking-[0.16em] text-[#52664c] shadow-sm" data-id="element-247" data-mp="s3u2lss5xe0q">
                      {product.label}
                    </span>
                    <img src={product.image} alt={`Portada de ${product.title}`} className="relative h-auto max-h-[490px] w-auto max-w-[250px] object-contain shadow-[14px_20px_32px_rgba(38,48,35,0.22)] sm:max-w-[290px]" data-id="element-248" data-mp="d5zib6xhykf" />
                  </div>
                  <div className="p-7 sm:p-9" data-id="element-249" data-mp="1pqatogaayve1">
                    <div className="flex items-center gap-3 text-[#66805c]" data-id="element-250" data-mp="1kshonqkqk7fc">
                      <ProductIcon size={21} strokeWidth={1.5} aria-hidden="true" data-id="element-251" data-mp="1kulsy9mjr8g5" />
                      <p className="text-[11px] font-bold tracking-[0.16em]" data-id="element-252" data-mp="1wt7lbf8lf0fn">
                        {product.label}
                      </p>
                    </div>
                    <h3 className="font-display mt-5 text-3xl text-[#30452e]" data-id="element-253" data-mp="26t88jc9l20p4">
                      {product.title}
                    </h3>
                    <p className="mt-4 max-w-xl leading-7 text-[#62705f]" data-id="element-254" data-mp="19713k19da6c8">
                      {product.description}
                    </p>
                    <h4 className="mt-8 text-[11px] font-bold uppercase tracking-[0.16em] text-[#52664c]" data-id="element-255" data-mp="1j3nloiab6jak">
                      Incluye
                    </h4>
                    <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-256" data-mp="1nw71llwgxqij">
                      {product.benefits.map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-6 text-[#586655]" data-id="element-257" data-mp="vd9sgofzmeee">
                          <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={14} strokeWidth={2} data-id="element-258" data-mp="ivgyay4mj9yk" />
                          <span data-id="element-259" data-mp="8xt2e4va7wet">{benefit}</span>
                        </li>)}
                    </ul>
                  </div>
                </motion.article>;
          })}

            <motion.aside initial={{
            opacity: 0,
            y: 18
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.5,
            delay: 0.18
          }} className="overflow-hidden rounded-2xl border border-[#dfe5d8] bg-[#fffefa] shadow-[0_14px_35px_rgba(53,70,49,0.10)]" aria-labelledby="complete-system-title" data-id="element-260" data-mp="3oglzv09b65">
              <div className="bg-[#f2f3eb] p-4 sm:p-6" data-id="element-261" data-mp="1a14eme2s04c6">
                <img src="https://cdn.magicpatterns.com/uploads/kwFw7QvCpLGEdkwY1o1dUk/ChatGPT_Image_17_jul_2026,_09_44_00.png" alt="Sistema Hábitos para una Vida Saludable con guía práctica, cocina antiinflamatoria, recetario déficit calórico y planificador nutricional" className="h-auto w-full rounded-xl object-contain shadow-[0_10px_25px_rgba(48,64,43,0.13)]" data-id="element-262" data-mp="v4vhpj6cy32x" />
              </div>
              <div className="p-7 sm:p-9" data-id="element-263" data-mp="cfp42akf81nz">
                <p className="text-[11px] font-bold tracking-[0.16em] text-[#66805c]" data-id="element-264" data-mp="hcfkx041v1ag">
                  PACK PREMIUM
                </p>
                <h3 id="complete-system-title" className="font-display mt-4 text-3xl leading-tight text-[#30452e]" data-id="element-265" data-mp="3dpprq0sjboq">
                  Todo lo que necesitas para avanzar con confianza
                </h3>
                <p className="mt-4 leading-7 text-[#62705f]" data-id="element-266" data-mp="3fxblv4ss572a">
                  No estás comprando un solo libro. Recibes un sistema creado
                  para ayudarte a elegir mejor, organizar tus comidas y dejar de
                  sentir que cada semana tienes que volver a empezar.
                </p>
                <p className="mt-4 leading-7 text-[#62705f]" data-id="element-267" data-mp="7ojrw6qo3euq">
                  El catálogo reúne más de 550 recetas, además de planes,
                  herramientas y guías prácticas para que siempre tengas una
                  opción clara cuando llegue la hora de comer.
                </p>

                <ul className="mt-7 grid gap-x-5 gap-y-2.5 sm:grid-cols-2" data-id="element-268" data-mp="cfteszku042x">
                  {['Guía principal Hábitos para una Vida Saludable', 'Cocina Antiinflamatoria', 'Recetario Déficit Calórico', 'Planificador Nutricional', 'Ideas para cada comida del día', 'Calendario de alimentación de 30 días', 'Meal Prep', 'Listas inteligentes', 'Acceso inmediato', 'Compatible con celular, tablet y computadora'].map(benefit => <li key={benefit} className="flex items-start gap-2 text-sm leading-6 text-[#586655]" data-id="element-269" data-mp="12whrs5k9iyye">
                      <CheckIcon className="mt-1 shrink-0 text-[#719063]" size={14} strokeWidth={2} data-id="element-270" data-mp="ab899jc3akst" />
                      <span data-id="element-271" data-mp="k7b7wf7qg1b0">{benefit}</span>
                    </li>)}
                </ul>

                <div className="mt-8 inline-flex items-center gap-2 rounded-full border border-[#b9c9ad] bg-[#f2f6ed] px-4 py-2.5 text-xs font-bold tracking-[0.05em] text-[#486044]" data-id="element-272" data-mp="3smbqmil31xm2">
                  <CheckIcon size={15} strokeWidth={2} data-id="element-273" data-mp="235zcb6ow0hsj" />
                  Acceso inmediato después de tu compra
                </div>
              </div>
            </motion.aside>
          </div>

          <motion.aside initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.55
        }} className="mx-auto mt-16 max-w-5xl rounded-[22px] border border-[#c9d7c1] bg-[#dfe9d8] px-6 py-12 text-center shadow-[0_16px_38px_rgba(53,70,49,0.10)] sm:px-12 sm:py-16" aria-labelledby="launch-offer-title" data-id="element-274" data-mp="1t9mjeb1627yu">
            <p className="mx-auto inline-flex rounded-full bg-[#657b5b] px-4 py-2 text-[10px] font-bold tracking-[0.18em] text-[#fff8e8]" data-id="element-275" data-mp="11gm4yz4ojgeg">
              🔥 OFERTA ESPECIAL DE LANZAMIENTO
            </p>

            <h3 id="launch-offer-title" className="font-display mx-auto mt-7 max-w-2xl text-3xl leading-tight text-[#30452e] sm:text-4xl" data-id="element-276" data-mp="384cs71s7fvs2">
              Dale a tu alimentación una guía que puedas seguir de verdad.
            </h3>

            <div className="mt-9" data-id="element-277" data-mp="2thjkoioxfuaf">
              <p className="text-lg font-medium text-[#7b8375] line-through" data-id="element-278" data-mp="2tg8fcefu2eh7">
                $197 USD
              </p>
              <p className="font-display mt-1 text-6xl leading-none text-[#2f5432] sm:text-8xl" data-id="element-279" data-mp="2pd3iareiv4zy">
                $29.99 USD
              </p>
            </div>

            <p className="mx-auto mt-7 max-w-3xl text-base leading-7 text-[#4c6049] sm:text-lg" data-id="element-280" data-mp="2fhrz9ww2zbme">
              Estás invirtiendo en Hábitos para una Vida Saludable: un sistema
              completo para dejar de depender de dietas, comer con más claridad y
              construir una rutina que puedas sostener a tu manera.
            </p>

            <div className="mt-7 flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-[#506548]" data-id="element-281" data-mp="8opwktvwimk7">
              <span data-id="element-282" data-mp="l8wmywdol996">Ahorras más del 80%</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-283" data-mp="l7lhms4l7tfy">
                •
              </span>
              <span data-id="element-284" data-mp="q0ejn88o8noc">Pago único</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-285" data-mp="uyy7xfaqmbjv">
                •
              </span>
              <span data-id="element-286" data-mp="3uecq9u70adg0">Sin mensualidades</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-287" data-mp="3ufecmuth2md1">
                •
              </span>
              <span data-id="element-288" data-mp="2asmsrfrukji">Acceso para siempre</span>
              <span aria-hidden="true" className="text-[#93a58b]" data-id="element-289" data-mp="79n5zuhnib45">
                •
              </span>
              <span data-id="element-290" data-mp="c86pzpcopctv">Descarga inmediata</span>
            </div>

            <a href={checkoutUrl} onClick={handleCheckoutClick} className="mt-10 inline-flex min-h-16 items-center justify-center rounded-full bg-[#3f603d] px-8 text-center text-sm font-bold tracking-[0.06em] text-white shadow-[0_10px_20px_rgba(48,69,46,0.16)] transition duration-300 hover:-translate-y-0.5 hover:bg-[#304d30] hover:shadow-[0_14px_26px_rgba(48,69,46,0.22)] focus:outline-none focus:ring-2 focus:ring-[#496d46] focus:ring-offset-2 focus:ring-offset-[#dfe9d8]" data-id="element-291" data-mp="c6diy8y5sqlc">
              QUIERO COMENZAR MI CAMBIO
            </a>

            <div className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-x-6 gap-y-4 text-xs font-medium text-[#50614b]" data-id="element-292" data-mp="30ku9xlddlssg">
              <span className="inline-flex items-center gap-2" data-id="element-293" data-mp="3akcwm9ko7so7">
                <LockKeyholeIcon size={15} aria-hidden="true" data-id="element-294" data-mp="3ak32qawi91d8" />
                Pago 100% seguro
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-295" data-mp="3odkm9vp6ye39">
                <ZapIcon size={15} aria-hidden="true" data-id="element-296" data-mp="3kbfwj81v61lw" />
                Acceso inmediato
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-297" data-mp="251k5dj8tzpm">
                <DownloadIcon size={15} aria-hidden="true" data-id="element-298" data-mp="3tbm4keesm9do" />
                Descarga digital
              </span>
              <span className="inline-flex items-center gap-2" data-id="element-299" data-mp="gsjpme4mqyd3">
                <MonitorSmartphoneIcon size={15} aria-hidden="true" data-id="element-300" data-mp="lq1o1al0tv6u" />
                Compatible con celular, tablet y computadora
              </span>
            </div>
          </motion.aside>

          <div className="mx-auto mt-8 max-w-6xl border-l-2 border-[#809675] bg-[#f7f8f2] px-7 py-7 sm:px-10" data-id="element-301" data-mp="brvo2yiryz4m">
            <p className="text-xs font-bold tracking-[0.18em] text-[#667d5c]" data-id="element-302" data-mp="3u5lfc424t3j9">
              VALOR TOTAL DEL SISTEMA
            </p>
            <div className="mt-4 grid gap-4 text-sm leading-6 text-[#53634e] sm:grid-cols-2 lg:grid-cols-4" data-id="element-303" data-mp="2s8x76no9bpt">
              {['Guía para crear hábitos saludables', 'Plan de alimentación de 30 días', 'Herramientas para organizar tus comidas', 'Acceso inmediato en celular, tablet y computadora'].map(value => <p key={value} className="flex items-start gap-2" data-id="element-304" data-mp="3f7knpm8addux">
                  <CheckIcon className="mt-1 shrink-0 text-[#6d8662]" size={15} strokeWidth={2} data-id="element-305" data-mp="1lqncecrlvp2p" />
                  <span data-id="element-306" data-mp="1gxlvy0br3hh0">{value}</span>
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-[#fcfbf7] py-24 sm:py-32" data-id="element-307" data-mp="1720mxi89lgxr">
        <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-308" data-mp="16zedte5q6tdf">
          <div className="flex flex-col justify-between gap-6 sm:flex-row sm:items-end" data-id="element-309" data-mp="24noiy20t5x8r">
            <div data-id="element-310" data-mp="1zqy2vep071nc">
              <p className="text-xs font-bold tracking-[0.2em] text-[#6d8063]" data-id="element-311" data-mp="1zqfz7x00hl5e">
                APRENDE HACIENDO
              </p>
              <h2 className="font-display mt-5 text-4xl text-[#2d3b2c] sm:text-5xl" data-id="element-312" data-mp="1uso998ixg93u">
                ¿Qué aprenderás?
              </h2>
            </div>
            <p className="max-w-sm leading-7 text-[#64705f]" data-id="element-313" data-mp="jcpvirct0ywa">
              Pequeñas herramientas para hacer de la alimentación saludable una
              parte natural de tu vida.
            </p>
          </div>
          <div className="mt-12 grid gap-px border border-[#e1e3db] bg-[#e1e3db] sm:grid-cols-2 lg:grid-cols-3" data-id="element-314" data-mp="2qyzn50wj1yqz">
            {learning.map(([title, Icon]) => {
            const LearningIcon = Icon as typeof LeafIcon;
            return <div key={title as string} className="flex min-h-36 items-center gap-5 bg-[#fcfbf7] p-7" data-id="element-315" data-mp="34ojktsb945tf">
                  <LearningIcon className="text-[#658057]" size={24} strokeWidth={1.5} data-id="element-316" data-mp="39nmrtiaskm41" />
                  <span className="text-base font-medium text-[#465342]" data-id="element-317" data-mp="3ipnn49mgsy32">
                    {title as string}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </section>
    </>;
}